import { FC } from "react";

import {
  ArrowRightIconSVG,
  CheckRegularSVG,
  CloseModalSVG,
  CopySolidSVG,
  DownloadIconSVG,
  EditIconSVG,
  FileCheckSVG,
  ForwardSVG,
  GradebookSVG,
  LoginSVG,
  MessageReadSVG,
  MessageUnreadSVG,
  OpenedMessageSVG,
  PlayUnitSVG,
  PlusIconSVG,
  PreviewIconSVG,
  ReplySVG,
  ReportsSVG,
  ResetSVG,
  RotateLeftSVG,
  ScoreCalculatorSVG,
  SynchronizeSVG,
  TranslateSVG,
  TrashAltSVG,
  UpdateExpirationDateSVG,
  UserMinusSVG,
  UserPlusSVG,
} from "@epignosis_llc/gnosis/icons";

import {
  ActionEntry,
  ActionRecord,
} from "@components/CustomTable/components/TableActions/GenericAction/types";

const createActionEntry = (
  icon: FC<{ height?: number }>,
  height: number,
  prefix: string,
): ActionEntry => ({
  icon,
  height,
  testId: `${prefix}-action`,
});

export const actionMap: ActionRecord<{
  icon: FC<{ height?: number }>;
  height: number;
  testId: string;
}> = {
  add: createActionEntry(PlusIconSVG, 16, "add"),
  approve: createActionEntry(CheckRegularSVG, 20, "approve"),
  clone: createActionEntry(CopySolidSVG, 30, "clone"),
  courseCloneAndTranslate: createActionEntry(TranslateSVG, 30, "course-clone-and-translate"),
  complete: createActionEntry(FileCheckSVG, 32, "complete"),
  decline: createActionEntry(CloseModalSVG, 30, "decline"),
  delete: createActionEntry(TrashAltSVG, 16, "delete"),
  download: createActionEntry(DownloadIconSVG, 32, "download"),
  edit: createActionEntry(EditIconSVG, 32, "edit"),
  enroll: createActionEntry(UserPlusSVG, 32, "enroll"),
  forward: createActionEntry(ForwardSVG, 32, "forward-message"),
  grade: createActionEntry(GradebookSVG, 32, "grade"),
  loginAs: createActionEntry(LoginSVG, 30, "login"),
  markAsRead: createActionEntry(MessageUnreadSVG, 28, "mark-as-read"),
  markAsUnread: createActionEntry(MessageReadSVG, 28, "mark-as-unread"),
  opened: createActionEntry(OpenedMessageSVG, 32, "opened-message"),
  preview: createActionEntry(PreviewIconSVG, 32, "preview"),
  reply: createActionEntry(ReplySVG, 32, "reply-message"),
  reports: createActionEntry(ReportsSVG, 30, "reports"),
  resend: createActionEntry(ForwardSVG, 30, "resend"),
  reset: createActionEntry(ResetSVG, 32, "reset"),
  resetUnit: createActionEntry(RotateLeftSVG, 16, "reset-unit"),
  run: createActionEntry(PlayUnitSVG, 30, "run"),
  score: createActionEntry(ScoreCalculatorSVG, 32, "score"),
  sync: createActionEntry(SynchronizeSVG, 32, "synchronize"),
  unenroll: createActionEntry(UserMinusSVG, 32, "unenroll"),
  updateExpirationDate: createActionEntry(UpdateExpirationDateSVG, 32, "update-expiration-date"),
  view: createActionEntry(ArrowRightIconSVG, 32, "view"),
};
